import Cookies from "js-cookie";
import { ACCESS_TOKEN_KEY } from "../config/env";

export const getAccessToken = (): string | undefined => {
   return Cookies.get(ACCESS_TOKEN_KEY);
 
};

export const setToken = (accessToken: string): void => {
  Cookies.set(ACCESS_TOKEN_KEY, accessToken, {
    secure: false, // 🔥 IMPORTANT en local
    sameSite: "lax", // plus safe que strict en dev
  });
};

export const clearToken = (): void => {
  Cookies.remove(ACCESS_TOKEN_KEY);
};